import React, { Component } from "react";
import { getClass } from "../../helpers/formatHelpers";

class ExternalWeb extends Component {
  render() {
    const { url, isMobileVersion } = this.props;
    return (
      <div
        className={`flex flex-col flex-1 ${getClass("background", true)} ${
          isMobileVersion ? "h-[448px]" : "h-[520px]"
        }`}>
        <iframe
          className="lazyload"
          loading="lazy"
          src={url}
          height={600}
          title="map"></iframe>
      </div>
    );
  }
}

export default ExternalWeb;
